module.exports = __webpack_public_path__ + "static/img/fish50.81811ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish50.png
// module id = Mp/D
// module chunks = 0